
import { defineComponent } from "vue";
import { formatDay2 } from "@/utils/dateTimeFormatter";
import PageTitle from "@/components/PageTitle.vue";
import PostsBlock from "@/components/PostsBlock.vue";
// import Button from "@/components/Button.vue";
// import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import pressLinksByDays from "@/data/pressLinksByDays";
export default defineComponent({
  components: {
    PageTitle,
    PostsBlock,
    // Button,
    // ArrowIcon
  },
  setup() {
    return {
      pressLinksByDays,
      formatDay2,
    };
  },
});
